import { useTranslation } from 'react-i18next'
import React, { useMemo } from 'react'

import { useSegmentationForm, useSegmentationFormActions } from '../_form/SegmentationFormHandler'
import GroupCardPicker from '../../../../containers/groups/select/cardPicker/GroupCardPicker'

export const useGroupStepDef = () => {
  const { t } = useTranslation('editSegmentation')
  const form = useSegmentationForm()

  return useMemo(
    () => ({
      title: t('groupStep.title'),
      subtitle: t('groupStep.subtitle'),
      Component: GroupStep,
      validate: () => {
        if (!form.userGroups.length) return [false, t('groupStep.selectGroupRequired')]
        return [true]
      }
    }),
    [form.userGroups, form.serviceTypes, t]
  )
}

const GroupStep = () => {
  const form = useSegmentationForm()
  const { handleChange } = useSegmentationFormActions()

  return (
    <GroupCardPicker idField="id" value={form.userGroups} onChange={handleChange('userGroups')} multiple useSelectAll />
  )
}

export default GroupStep
